/* Beneos Messschicht.

   Drei Aufgaben, in dieser Reihenfolge:

   1. Consent Mode v2 vorbelegen, bevor irgendein Google-Tag laedt. Im EWR und
      in Grossbritannien steht alles auf denied, ueberall sonst auf granted.
      Das Einwilligungsbanner (Pandectes) schickt spaeter das update. Faellt das
      Banner aus, bleibt es bei denied, also bei der datensparsamen Variante.

   2. Die Klickkennung festhalten. Google haengt gclid, gbraid oder wbraid an
      die Landingseite. Wer danach durch den Shop laeuft, verliert sie aus der
      Adresse. Wir legen sie mit den utm-Werten in localStorage ab und merken
      uns getrennt, womit der Besucher zuerst kam und womit zuletzt.

   3. Ereignisse melden, die auf dem Weg zum Kauf liegen und die es im Checkout
      nicht mehr gibt. Der Kauf selbst kommt aus einem Custom Pixel, weil der
      Checkout kein Theme-Code ist.

   Der Kauf wird hier bewusst NICHT gemeldet. Zwei Quellen fuer dasselbe
   Ereignis waeren doppelt gezaehlte Conversions.
*/
(function () {
  'use strict';

  var ADS_ID = 'AW-573686705';
  var SPEICHER = 'beneos_attr';
  var HALTBAR_TAGE = 90;

  /* Laender, in denen ohne Einwilligung nichts gesetzt wird. EWR plus
     Grossbritannien plus Schweiz. Die Schweiz gehoert nicht zum EWR, ihr
     Datenschutzrecht ist seit der Revision aber nah genug dran. */
  var EINWILLIGUNGSPFLICHT = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
    'HU', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT',
    'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'GB', 'CH'
  ];

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;

  /* ---- 1. Consent Mode ---------------------------------------------------
     Die regionale Vorbelegung muss vor dem config stehen, sonst feuert der
     Tag einmal ungefragt, bevor die Regel greift. */
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
    region: EINWILLIGUNGSPFLICHT
  });
  gtag('consent', 'default', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted'
  });
  /* Ohne Einwilligung schickt Google nur noch anonyme Signale, und die
     Klickkennung wandert in die Adresse statt in ein Cookie. */
  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);

  gtag('js', new Date());
  gtag('config', ADS_ID, { allow_enhanced_conversions: true });

  /* Tag nachladen. defer waere hier falsch: die Warteschlange oben muss beim
     Ausfuehren schon stehen, und genau das leistet dataLayer. */
  (function () {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ADS_ID;
    document.head.appendChild(s);
  })();

  /* ---- 1b. Einwilligung an Google zurueckmelden ---------------------------
     Die Vorbelegung oben sagt Google nur, wovon es OHNE Antwort ausgehen soll.
     Die Antwort selbst muss als eigener update-Aufruf hinterher. Fehlt er,
     stimmt der Besucher zu und Google erfaehrt es nie: die Einwilligung liegt
     vor, die Conversion geht trotzdem verloren.

     Der Aufruf muss NACH dem config stehen, sonst ueberschreibt die
     Vorbelegung die Zustimmung. */

  function janein(v) {
    /* Shopify liefert je nach Weg 'yes'/'no'/'' oder true/false/undefined. */
    if (v === true || v === 'yes') return 'granted';
    if (v === false || v === 'no') return 'denied';
    return null;   // noch nicht beantwortet, Vorbelegung bleibt stehen
  }

  function consentMelden(stand) {
    if (!stand) return;
    var werbung   = janein(stand.marketing);
    var messung   = janein(stand.analytics);
    var komfort   = janein(stand.preferences);
    var neu = {};
    if (werbung) {
      neu.ad_storage = werbung;
      neu.ad_user_data = werbung;
      neu.ad_personalization = werbung;
    }
    if (messung) neu.analytics_storage = messung;
    if (komfort) {
      neu.functionality_storage = komfort;
      neu.personalization_storage = komfort;
    }
    if (!Object.keys(neu).length) return;
    try { gtag('consent', 'update', neu); } catch (e) { /* Blocker */ }
  }

  /* Wiederkehrer haben laengst zugestimmt, sollen aber nicht bis zur naechsten
     Bannerinteraktion als "verweigert" gelten. Deshalb den gespeicherten Stand
     einmal aktiv lesen. Die Einwilligungs-API laedt eigenstaendig, darum ein
     kurzer Anlauf statt eines einzelnen Versuchs. */
  (function () {
    var versuche = 0;
    function lesen() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        consentMelden(cp.currentVisitorConsent());
        return;
      }
      if (++versuche < 20) setTimeout(lesen, 250);
    }
    lesen();
  })();

  /* Und die frische Antwort aus dem Banner. */
  document.addEventListener('visitorConsentCollected', function (ev) {
    var d = (ev && ev.detail) || {};
    consentMelden({
      marketing: d.marketingAllowed,
      analytics: d.analyticsAllowed,
      preferences: d.preferencesAllowed
    });
  });

  /* ---- 2. Klickkennung ---------------------------------------------------- */
  function jetzt() { return Date.now(); }

  function lesen() {
    try {
      var roh = window.localStorage.getItem(SPEICHER);
      if (!roh) return null;
      var d = JSON.parse(roh);
      if (!d || !d.first || !d.first.ts) return null;
      var alter = (jetzt() - d.first.ts) / 86400000;
      if (alter > HALTBAR_TAGE) { window.localStorage.removeItem(SPEICHER); return null; }
      return d;
    } catch (e) { return null; }
  }

  function schreiben(d) {
    try { window.localStorage.setItem(SPEICHER, JSON.stringify(d)); } catch (e) { /* privater Modus */ }
  }

  function ausAdresse() {
    var p = new URLSearchParams(window.location.search);
    var treffer = {};
    ['gclid', 'gbraid', 'wbraid'].forEach(function (k) {
      var v = p.get(k);
      if (v) treffer[k] = v;
    });
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var v = p.get(k);
      if (v) treffer[k] = v;
    });
    return Object.keys(treffer).length ? treffer : null;
  }

  var neu = ausAdresse();
  var stand = lesen();

  if (neu) {
    neu.ts = jetzt();
    neu.landing = window.location.pathname;
    if (!stand) {
      /* Erster Kontakt. Beide Seiten zeigen auf dieselbe Kampagne. */
      stand = { first: neu, last: neu };
    } else {
      /* Wiederkehrer ueber eine zweite Anzeige. Der erste Kontakt bleibt
         stehen, denn er hat die Aufmerksamkeit erzeugt. */
      stand.last = neu;
    }
    schreiben(stand);
  }

  window.BeneosAttr = {
    lesen: lesen,
    /* Fuer den serverseitigen Abgleich: flache Form, wie sie die Cloud erwartet. */
    flach: function () {
      var d = lesen();
      if (!d) return null;
      return {
        gclid: (d.last && d.last.gclid) || (d.first && d.first.gclid) || null,
        gbraid: (d.last && d.last.gbraid) || (d.first && d.first.gbraid) || null,
        wbraid: (d.last && d.last.wbraid) || (d.first && d.first.wbraid) || null,
        utm_source: d.first && d.first.utm_source || null,
        utm_medium: d.first && d.first.utm_medium || null,
        utm_campaign: d.first && d.first.utm_campaign || null,
        utm_term: d.first && d.first.utm_term || null,
        utm_content: d.first && d.first.utm_content || null,
        landing_url: d.first && d.first.landing || null,
        first_seen: d.first && d.first.ts || null,
        last_seen: d.last && d.last.ts || null
      };
    }
  };

  /* ---- 2b. An die Cloud melden --------------------------------------------
     Die Klickkennung nuetzt erst etwas, wenn sie an einem Konto haengt. Sie geht
     deshalb nur raus, wenn der Besucher angemeldet ist, und dann einmal je
     Sitzung. Ohne Anmeldung passiert nichts, der erste Seitenaufruf nach dem
     Login holt es nach. */
  var GEMELDET = 'beneos_attr_gemeldet';

  /*
   * Fragt die Einwilligung und wartet dabei auf die Shopify-API.
   *
   * Zwei Faelle, die man nicht verwechseln darf:
   *
   * 1. Die API ist noch nicht geladen. Sie kommt mit dem Storefront-Bundle und
   *    ist beim ersten Durchlauf oft noch nicht da. Wer das als "keine Regel"
   *    liest, sendet trotz Ablehnung. Genau dieser Fehler war am 2026-07-31
   *    kurz live und hat zwei Zeilen erzeugt, die dort nicht hingehoerten.
   *
   * 2. Die API kommt gar nicht. Shopify liefert sie **nur in Regionen mit
   *    Einwilligungspflicht** aus. Fehlt sie dauerhaft, unterliegt dieser
   *    Besucher keiner solchen Regel. Das ist der Normalfall in den USA, und
   *    das ist unser groesster Markt.
   *
   * Der Unterschied zwischen beiden ist einzig die Zeit. Deshalb wird acht
   * Sekunden gewartet, grosszuegig gegenueber dem, was das Bundle braucht, und
   * erst danach als Fall 2 gewertet.
   *
   * Achtung beim Pruefen: Shopify entscheidet nach dem **Markt** des Besuchers,
   * nicht nach der IP allein. Ein Browser mit localization=US sieht auch aus
   * Deutschland keine API. Zum Testen den Markt umstellen, nicht nur die Sprache.
   */
  function mitEinwilligung(weiter) {
    var versuche = 0;
    (function warte() {
      var cp = null;
      try { cp = window.Shopify && window.Shopify.customerPrivacy; } catch (e) { cp = null; }
      if (cp && typeof cp.marketingAllowed === 'function') {
        try { weiter(!!cp.marketingAllowed()); } catch (e) { weiter(false); }
        return;
      }
      if (cp && typeof cp.userCanBeTracked === 'function') {
        try { weiter(!!cp.userCanBeTracked()); } catch (e) { weiter(false); }
        return;
      }
      if (++versuche < 32) { setTimeout(warte, 250); return; }
      weiter(true);
    })();
  }

  function anCloud() {
    if (!document.body || !document.body.classList.contains('customer-logged-in')) return;
    try { if (window.sessionStorage.getItem(GEMELDET)) return; } catch (e) { return; }
    mitEinwilligung(function (erlaubt) { if (erlaubt) senden(); });
  }

  function senden() {
    /* Zweite Pruefung: zwischen Frage und Antwort kann eine Sitzung schon
       gemeldet haben, etwa wenn zwei Ereignisse gleichzeitig anlaufen. */
    try { if (window.sessionStorage.getItem(GEMELDET)) return; } catch (e) { return; }

    var d = window.BeneosAttr.flach();
    if (!d) return;
    /* Ohne Kampagnenspur gibt es nichts zu melden. */
    if (!d.gclid && !d.gbraid && !d.wbraid && !d.utm_source) return;

    fetch('/apps/beneos/library?resource=attribution', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(d),
      keepalive: true
    }).then(function (r) {
      /* Auch ein "kein_konto" ist eine Antwort: innerhalb der Sitzung aendert
         sich daran nichts mehr, also nicht bei jedem Seitenaufruf erneut. */
      if (r.ok) { try { window.sessionStorage.setItem(GEMELDET, '1'); } catch (e) { } }
    }).catch(function () { /* Blocker oder offline, naechste Sitzung erneut */ });
  }

  /* Pandectes sammelt die Einwilligung erst nach dem Laden ein. */
  document.addEventListener('visitorConsentCollected', anCloud);

  /* ---- 3. Ereignisse ------------------------------------------------------
     Nur Dinge, die im Checkout nicht mehr passieren. Der Kauf kommt aus dem
     Custom Pixel unter Kundenereignisse. */
  function melden(name, daten) {
    try { gtag('event', name, daten || {}); } catch (e) { /* Blocker */ }
  }

  function ereignisse() {
    var pfad = window.location.pathname;

    anCloud();

    if (/\/pages\/library/.test(pfad)) {
      var zugang = new URLSearchParams(window.location.search).get('access');
      melden(zugang === 'free' ? 'beneos_library_free_view' : 'beneos_library_view');
    }
    if (/\/pages\/foundry-vtt-setup/.test(pfad)) melden('beneos_foundry_setup_view');
    if (/\/products\//.test(pfad) && document.querySelector('[data-bundle-contents], .bundle-contents')) {
      melden('beneos_bundle_view');
    }

    /* Klicks auf Patreon und auf den Gratis-Einstieg. Delegiert, damit auch
       Elemente erfasst werden, die erst spaeter im DOM landen. */
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (/patreon\.com/i.test(href)) {
        melden('beneos_patreon_click', { link_url: href, link_text: (a.innerText || '').trim().slice(0, 60) });
      } else if (/access=free/.test(href) || /\/account\/register/.test(href)) {
        melden('beneos_free_start', { link_url: href });
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ereignisse, { once: true });
  } else {
    ereignisse();
  }
})();
